import { Loading as RaLoading, LoadingProps as RaLoadingProps } from 'react-admin';

export type LoadingProps = RaLoadingProps;

export const Loading = RaLoading;
